import { requestPlatform } from '@/plugins/axios'
// { query,pagenum,pagesize }
export function getFactoryList(params) {
   return requestPlatform({
        url: 'factory/getInfo',
        method: 'GET',
        params: params
      })
}
// {factoryname,phone}
export function addFactory(data) {
  return requestPlatform({
    url: 'factory/create',
    method: 'POST',
    data: data
  })
}
export function removeFactoryById(id) {
 return requestPlatform({
    url: `factory/delete/${id}`,
    method: 'DELETE'
  })
}
// {editfrom}
export function editFactory(data) {
 return requestPlatform({
    url: 'factory/modify',
    method: 'POST',
    data: data
  })
}
export function showEditDialog(id) {
 return requestPlatform({
    url: `factory/getOne/${id}`,
    method: 'GET'
  })
}
